import { createThunkRoutine } from 'redux-thunk-routine';
import { USER_FETCH_PERMISSIONS_DATA, USER_SET } from './action-types';

export const FetchPermissionsRoutine = createThunkRoutine(USER_FETCH_PERMISSIONS_DATA);
export const SetUserRoutine = createThunkRoutine(USER_SET);
